export interface BasicInfoOnboardingForm {
  birthdate: Date | undefined;
  customProperties: {
    birthPlace: string;
  };
  firstName: string;
  lastName: string;
  street: string;
  city: string;
  postcode: string;
  country: string;
  phone: string;
}

/**
 * Step types returned by `GET /front/onboarding/next-step`. The endpoint
 * returns the remaining onboarding steps for the current user; an `external`
 * step with `provider: id_austria` is what enables the "Fill with ID Austria"
 * button on the Basic Profile step.
 */
export enum OnboardingStepType {
  PROFILE_NAME = 'profile_name',
  PROFILE_EMAIL = 'profile_email',
  PROFILE_PHONE = 'profile_phone',
  PROFILE_ADDRESS = 'profile_address',
  PROFILE_COUNTRY = 'profile_country',
  PROFILE_BIRTHDATE = 'profile_birthdate',
  EXTERNAL = 'external',
}

/** Every step type except the external provider step. */
export type ProfileOnboardingStepType = Exclude<OnboardingStepType, OnboardingStepType.EXTERNAL>;

export enum ExternalOnboardingProvider {
  ID_AUSTRIA = 'id_austria',
}

export interface OnboardingStepField {
  name: string;
  required: boolean;
}

interface OnboardingStepBase {
  skippable: boolean;
}

export interface ProfileOnboardingStep extends OnboardingStepBase {
  type: ProfileOnboardingStepType;
  fields: OnboardingStepField[];
}

export interface ExternalOnboardingStep extends OnboardingStepBase {
  type: OnboardingStepType.EXTERNAL;
  provider: ExternalOnboardingProvider | string;
  title: string;
  /** Base URL of the external provider page (e.g. NEWCON's ID Austria app). */
  redirectUrl: string;
  /** Mobile deep link the provider redirects back to; unused on web. */
  returnScheme?: string;
}

export type OnboardingStep = ProfileOnboardingStep | ExternalOnboardingStep;

/**
 * Payload from `GET /front/customers/signed`. The signed `jwt` is forwarded to the
 * external ID Austria page as the `signed-user-data` query param — that is what NEWCON
 * validates and uses to identify the user. `userId` is sent as the `user-id` param for
 * parity with mobile, but NEWCON ignores it (identity lives inside the JWT).
 */
export interface CustomerSigned {
  userId: number;
  authId: string;
  language?: string;
  homeBillableBranchId: number;
  jwt: string;
}
